<template>
    <div v-if="$store.state.is_manager">
        <div class="select-container clearfix" style="margin-top: 6%;margin-left: 33%;float: center;">
            <el-form ref="form" :model="form" label-width="130px">
                <el-form-item label="修改目录：">
                    <el-select v-model="value" placeholder="请选择">
                        <el-option
                                v-for="item in form.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目录名：">
                    <el-col :span="6">
                        <el-input v-model="form.title" placeholder="请输入您要修改的目录名"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">确认修改</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import axios from "axios";

    export default {
        name: "updateItem",
        data() {
            return {
                form: {
                    title: '',
                    options: [],
                },
                token: '',
                value: '',
            };
        },
        mounted: function () {
            var vm = this;
            if (!(vm.$store.state.is_manager)) {
                this.$notify({
                    title: '没有权限',
                    message: '你没有操作当前菜单的权限',
                    type: 'error'
                });
                return;
            }
            if (vm.token == "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            this.$nextTick(function () {
                axios.get(vm.selectDirItems, {
                    withCredentials: true
                }).then((response) => {
                    if (response.data && response.data.status === 401) {
                        window.location = vm.loginRediret;
                        return;
                    }
                    let dirItem = response.data.data;
                    if (!dirItem || dirItem.length === 0) {
                        return;
                    }
                    vm.$set(vm.form, 'options', dirItem);
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                });
            });

        },
        computed: mapState({
            updateItem: function (state) {
                return state.updateItem;
            },
            selectDirItems: function (state) {
                return state.selectDirItems;
            },
        }),
        methods: {
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            onSubmit() {
                var vm = this;
                if (vm.value == '' || vm.form.title == '') {
                    vm.$message.error('信息不完整，请完善！');
                    return;
                }
                axios.post(vm.updateItem, {documentIndex: vm.value, documentTitle: vm.form.title}, {
                    withCredentials: true
                }).then((response) => {
                    vm.$notify({
                        title: '提示',
                        message: '修改成功',
                        type: 'success'
                    });
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                });
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code === 401) {
                        document.cookie = "currentURL=updateItem";
                        window.location = vm.loginRediret;
                    } else {
                        if (code === 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// updateItem.vue?c484cb30